module.exports = {
	'test': 'foo pt',


	/* MENU */

	'menu_home': 'HOME',
	'menu_about_us': 'QUEM SOMOS',
	'menu_investors': 'INVESTIDORES',
	'menu_contacts': 'CONTACTOS',
	'menu_portfolio': 'PORTFÓLIO',

	/*HOME PAGE*/

	'home_welcome_title': 'BEM-VINDO',
	'home_welcome_txt': 'A Sonagi desenvolve a sua atividade de forma sustentada, equilibrando as atividades de promoção com a gestão de activos imobiliários, tornando-se assim uma referência de qualidade em Portugal.',
	'home_thumbs_about_title': 'QUEM SOMOS',
	'home_thumbs_about_txt': 'Conheça a Sonagi e saiba mais sobre os seus valores, estratégia e equipa.',
	'home_thumbs_portfolio_title': 'PORTFÓLIO',
	'home_thumbs_portfolio_txt': 'A Sonagi é especialista nos setores de escritórios, residencial, retalho e logística. Saiba mais sobre os nossos investimentos imobiliários.',
	'home_thumbs_investors_title1': 'INVESTIDORES',
	'home_thumbs_investors_title2': 'AND SHAREHOLDERS',
	'home_thumbs_investors_txt': 'O principal objectivo da Sonagi é ganhar a confiança dos seus accionistas e investidores, proporcionando-lhes um crescimento sustentável e total transparência.',
	'home_portfolio_title': 'PORTFÓLIO EM DESTAQUE',
	'home_real_estate_title': 'EXCELÊNCIA E INOVAÇÃO',
	'home_real_estate_txt': 'A Sonagi é uma holding imobiliária com actividade nas áreas de investimento, gestão de activos e promoção imobiliária, que tem como accionista de referência a Sodim, holding da família Queiroz Pereira.',
	'home_ft_portfolio_txt': '',

	/*PRIVACY POLICY*/

	'privacy_policy_title': 'POLÍTICA DE PRIVACIDADE',
	'privacy_policy_welcome_txt': 'Consulte nesta página quais os dados recolhidos na utilização do website e como são tratados.',
	'privacy_policy_articles': [
		{
			'title': 'IDENTIFICAÇÃO DO RESPONSÁVEL PELO TRATAMENTO',
			'text': '<ul><li>Empresa: Sonagi - Imobiliária, S.A. ("SONAGI")</li><li>Sede: Av. Fontes Pereira de Melo, 14 - 7.º, 1050-121 Lisboa</li><li>NIPC: 502888083</li><li>Telefone: (+351) 213 184 800</li><li>E-mail: <a href="mailto: sonagi@sonagi.pt" class="icon-link">sonagi@sonagi.pt</a></li>',
		},
		{
			'title': 'INFORMAÇÃO',
			'text': 'A Lei da Proteção de Dados Pessoais (em diante “LPDP”) vigente e o Regulamento Geral sobre a Proteção de Dados (Regulamento (UE) 2016/679 do Parlamento Europeu e do Conselho de 27 de abril de 2016, em diante “RGPD”) asseguram a proteção das pessoas singulares no que diz respeito ao tratamento de dados pessoais e à livre circulação desses dados.<br><br>Nos termos legais, consideram-se dados pessoais qualquer “informação relativa a uma pessoa singular identificada ou identificável (“o titular dos dados”); é considerada identificável uma pessoa singular que possa ser identificada, direta ou indiretamente, em especial por referência a um identificador, como por exemplo um nome, um número de identificação, dados de localização, identificadores por via eletrónica ou a um ou mais elementos específicos da identidade física, fisiológica, genética, mental, económica, cultural ou social dessa pessoa singular”.<br><br>A proteção dos dados pessoais de todas as pessoas que de alguma forma se relacionam com a SONAGI constitui um compromisso fundamental para a nossa empresa, pelo que trabalhamos diariamente para assegurar os melhores níveis de proteção dos dados pessoais que tratamos, respeitando a legislação e todos os normativos e orientações nacionais e europeus aplicáveis ao seu tratamento. Na gestão da relação com os nossos fornecedores, prestadores de serviços, clientes e utilizadores podemos aceder aos respetivos dados pessoais, bem como poderemos ainda aceder aos dados pessoas de administradores e colaboradores SONAGI.<br><br>Mediante a aceitação da presente Política de Privacidade, pretendemos dar-lhe a conhecer como é que a SONAGI trata estes dados pessoais e as finalidades para as quais os trata, assim como informá-lo dos direitos que assistem aos titulares dos dados e a forma como os mesmos poderão exercer esses direitos. Em caso algum a SONAGI levará a cabo qualquer uma das seguintes atividades com os dados pessoais facultados, sem o consentimento prévio expresso do titular dos dados, salvo por obrigação legal previamente prevista:<br><br><ul>I.  Ceder a outras pessoas ou outras entidades, e/ou<br>II.  Transferir para fora do Espaço Económico Europeu (EEE).</ul>',
		},
		{
			'title': 'FINALIDADES DO TRATAMENTO DE DADOS PESSOAIS',
			'text': 'Os dados pessoais tratados pela SONAGI serão unicamente utilizados para as seguintes finalidades:<br><br><ul>I.  Cumprimento de obrigações legais;</br>II.  Gestão de relações contratuais com clientes e fornecedores;</br>III.  Prospeção do negócio;</br>IV.  Processamento de pedidos de informação;</br>V.  Processamento de reclamações.</ul>',
		},
		{
			'title': 'MEDIDAS DE SEGURANÇA',
			'text': 'A SONAGI declara que implementou e continuará a implementar as medidas de segurança de natureza técnica e organizativa necessárias para garantir a segurança dos dados pessoais que lhe sejam fornecidos visando evitar a sua alteração, perda, tratamento e/ou acesso não autorizado, tendo em conta o estado atual da tecnologia, a natureza dos dados armazenados e os riscos a que estão expostos.<br><br>A SONAGI garante a confidencialidade dos dados fornecidos.<br><br>Os dados pessoais são tratados com o nível de proteção legalmente exigível para garantir a segurança dos mesmos e evitar a sua alteração, perda, tratamento ou acesso não autorizado, tendo em conta o estado da tecnologia, sendo o utilizador consciente e aceitando que as medidas de segurança em Internet não são inexpugnáveis.<br><br>Sempre que aceder a dados pessoais a SONAGI compromete-se a:<br><br><ul><li>Armazená-los por intermédio de medidas de segurança, legalmente exigíveis, de natureza técnica e organizativa, que garantam a sua segurança, evitando assim a alteração, perda, tratamento ou acesso não autorizado, em conformidade com o estado da tecnologia em cada momento, a natureza dos dados e os possíveis riscos a que estejam expostos;</li><br><li>Utilizar os dados exclusivamente para as finalidades previamente definidas;</li><br><li>Certificar-se que os dados são tratados unicamente pelos colaboradores cuja intervenção seja necessária para satisfazer a solicitação do titular dos dados, estando os mesmos obrigados ao dever de sigilo e de confidencialidade. Existindo a possibilidade de a informação ser revelada a terceiros para os referidos fins, estes devem ser obrigados a guardar a devida confidencialidade em conformidade com o previsto neste documento.</li></ul>É, no entanto, da responsabilidade do utilizador garantir e assegurar que o computador que está a utilizar se encontra adequadamente protegido contra softwares nocivos, vírus informáticos e worms. Adicionalmente, deverá estar ciente que, sem a adoção de medidas de segurança adequadas (por exemplo, a configuração segura do programa de navegação, software antivírus atualizado, software de barreira de segurança e a não utilização de software de origem duvidosa), o risco dos dados pessoais e passwords serem acedidos por terceiros, sem autorização para tal, é agravado.',
		},
		{
			'title': 'EXERCÍCIO DOS DIREITOS',
			'text': 'De acordo com o disposto na legislação vigente e no RGPD, o titular pode exercer a todo o tempo os seus direitos de informação, acesso, retificação, apagamento, limitação, portabilidade e oposição, através de solicitação escrita dirigida à SONAGI pelos seguintes meios:<br><br><ul><li>Via postal para o endereço: Av. Fontes Pereira de Melo, 14 – 7.º, 1050–121 Lisboa;</li><li>Email para o endereço de correio eletrónico: <a href="mailto:sonagi@sonagi.pt" class="icon-link">sonagi@sonagi.pt</a></li></ul>',
		},
		{
			'title': 'AUTORIDADE DE CONTROLO',
			'text': 'Nos termos legais, o titular dos dados tem o direito de apresentar uma reclamação em matéria de proteção de dados pessoais à autoridade de controlo competente, a Comissão Nacional de Proteção de Dados (CNPD) <a href="https://www.cnpd.pt" target="_blank" class="icon-link">www.cnpd.pt</a>',
		},
		{
			'title': 'POLÍTICA DE COOKIES',
			'text': 'A política de cookies é parte integrante da política de privacidade do website da SONAGI. O acesso e navegação no website ou o uso dos seus serviços implica a aceitação dos termos e condições contidos na política de privacidade.<br><br>Para facilitar e proporcionar uma melhor experiência de navegação através do website, a SONAGI informa que utiliza cookies ou outros arquivos de funcionalidade similar (a seguir "cookies").<br><br>Devido ao modo como funcionam os standards de comunicação de Internet, o acesso aos websites pode implicar a utilização de cookies. A SONAGI é responsável pelos cookies e pelo tratamento dos dados obtidos através dos cookies, quer próprios, quer de terceiros, através do seu website, decidindo sobre o propósito, conteúdo e uso do tratamento dos dados recolhidos.<br><br><span style="font-weight: 700; text-decoration: underline">O que é um cookie?</span><br><br>Os cookies são arquivos que contêm pequenas quantidades de informações que são descarregadas para o dispositivo do utilizador quando visita uma página da internet.<br><br>O objetivo principal é reconhecer o utilizador sempre que acede ao website, permitindo também melhorar a qualidade e oferecer um melhor uso do site, visando simplificar a navegação.<br><br>Os cookies são essenciais para o funcionamento da internet; não danificam o equipamento ou dispositivo do utilizador e, se estiverem ativados na configuração do seu navegador, ajudam a identificar e resolver possíveis erros na operação do website.<br><br><span style="font-weight: 700; text-decoration: underline">Uso de cookies pela SONAGI</span><br><br>Ao aceder ao website, o utilizador aceita expressamente o uso deste tipo de cookies nos seus dispositivos. Se desativar os cookies, a navegação no website poderá não ser otimizada e alguns das funcionalidades do website poderão não funcionar corretamente.<br><br>A SONAGI utiliza Cookies especificamente para os propósitos supra identificados e caso a SONAGI venha a utilizar outros cookies com a finalidade de conceder mais e melhores serviços, o utilizador será devidamente informado.<br><br><span style="font-weight: 700; text-decoration: underline">Configuração do utilizador para evitar cookies</span><br><br>Em conformidade com a legislação vigente é prestada informação relativa à forma como o utilizador pode configurar o browser para gerir e manter a sua privacidade e segurança em relação aos cookies, através de links para aceder ao website de suporte oficial dos principais navegadores para que poder decidir se aceita ou não o uso de cookies.<br><br>Deve entender-se que o utilizador aceita o uso de cookies se continuar a navegar nesta página sem antes proceder à sua desativação. As definições de cookies podem ser alteradas nas preferências do seu navegador, seguindo as indicações seguintes:<br><br><ul><span style="font-weight: 700">Chrome:</span><br>I. Clique em “Definições” na barra de ferramentas;<br>II. Clique em “Mostrar definições avançadas”;<br>III. Na secção “Privacidade”, clique em “Definições de Conteúdo”;<br>IV. Selecione a opção “Bloquear definições dos dados por parte dos Websites”;<br>V. Pode alterar as seguintes definições na secção “Cookies”: Eliminar cookies; Bloquear cookies por predefinição; Permitir cookies por predefinição; Manter cookies e dados do Website por predefinição até sair do navegador de Internet; Criar exceções para cookies de Websites ou domínios específicos.<br><br><span style="font-weight: 700">Firefox:</span><br>I. Clique no menu “Ferramentas”;<br>II. Selecione “Opções”;<br>III. Clique no ícone “Privacidade”;<br>IV. Na secção “Cookies”, desative a opção “Aceitar cookies dos sites”;<br>V. Clique em “OK” para guardar as alterações e fechar.<br><br><span style="font-weight: 700">Internet Explorer:</span><br>I. Clique no menu “Ferramentas” e escolha a opção “Opções de Internet”;<br>II. Selecione o separador “Privacidade”;<br>III. Mova a barra até surgir a expressão “Bloquear todos os cookies”.<br><br><span style="font-weight: 700">Safari:</span><br>I. Selecione “Preferências”;<br>II. No painel superior, selecione o ícone “Privacidade”;<br>III. Na secção “Aceitar cookies”, selecione “Nunca”.<br><br><span style="font-weight: 700">Outros navegadores:</span><br>Por favor procure no menu “ajuda” do navegador de internet ou contacte o seu fornecedor.</ul>',
		}
	],


	/*INVESTORS*/

	'investors_title': 'INVESTIDORES',
	'investors_welcome_txt': 'O principal objectivo da Sonagi é ganhar a confiança dos seus investidores, proporcionando-lhes um crescimento sustentável e total transparência.',
	'investors_themes': [
		{
			'title': 'INFORMAÇÃO PARA O INVESTIDOR',
			'height': 600,
			'component': 'InvestorInfo',
			'opened': true,
			'params': {
				'trans': {
					'market_releases': 'COMUNICADOS',
				},
				'market_releases': {
					'initial_slide': 0,
					'slider_items': [
						{
							'name': 'DELIBERAÇÕES ASSEMBLEIA GERAL',
							'year': '23 ABRIL 2026',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Sonagi_2026.pdf',
						},
						{
							'name': 'DELIBERAÇÕES ASSEMBLEIA GERAL',
							'year': '19 MAIO 2025',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Sonagi_2025.pdf',
						},
						{
							'name': 'DELIBERAÇÕES ASSEMBLEIA GERAL',
							'year': '4 ABRIL 2024',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Sonagi_2024.pdf',
						},
						{
							'name': 'DELIBERAÇÕES ASSEMBLEIA GERAL',
							'year': '31 MAIO 2023',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Sonagi_2023.pdf',
						},
						{
							'name': 'DELIBERAÇÕES ASSEMBLEIA GERAL EXTRAORDINÁRIA',
							'year': '12 DEZ 2022',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Extraordinária_Sonagi_2022.pdf',
						},
						{
							'name': 'PARTICIPAÇÃO QUALIFICADA',
							'year': '2021',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_PQ_SonagiSGPS_202104.pdf',
						},
						{
							'name': 'PARTICIPAÇÃO QUALIFICADA',
							'year': '2020',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sodim_Comunicado_PQ_Sonagi_2020.pdf',
						},
						{
							'name': 'OPERAÇÕES DE DIRIGENTES',
							'year': '2020',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sodim_Comunicado_Dirigentes_Sonagi.pdf',

						},
						{
							'name': 'PARTICIPAÇÃO QUALIFICADA',
							'year': '2019',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_Sonagi_PQ_2019.PDF',
						},
						{
							'name': 'CONVERSÃO DE ACÇÕES',
							'year': '2017',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_Sonagi_CA_2017.pdf',
						},
						{
							'name': 'AQUISIÇÃO DE ACÇÕES',
							'year': '2015',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_Sonagi_AA_Longavia_2015.pdf',
						},
						{
							'name': 'AQUISIÇÃO DE ACÇÕES',
							'year': '2015',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_Sonagi_AA_Cimilonga_2015.pdf',
						}
					],
				},
			},
		},
		{
			'title': 'RELATÓRIO',
			'height': 400,
			'component': 'Report',
			'opened': true,
			'params': {
				'initial_slide': 0,
				'slider_items': [
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2025',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2025.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2024',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2024.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2023',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2023.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2022',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2022.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2021',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2021.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2020',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2020.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2019',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2019.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2018',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2018.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2017',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2017.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2016',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2016.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2015',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2015.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2014',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2014.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2013',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2013.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2012',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2012.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2011',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2011.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2010',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2010.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2009',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2009.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2008',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2008.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2007',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2007.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2006',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2006.pdf',
					},
					{
						'name': 'RELATÓRIO E CONTAS',
						'year': '2005',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2005.pdf',
					},
				],
			},
		},
		{
			'title': 'ACÇÕES',
			'height': 600,
			'component': 'Stocks',
			'opened': false,
			'params': {
				'trans': {
					'stock_market': 'MERCADO DE ACÇÕES',
					'qualified_holdings': 'PARTICIPAÇÕES QUALIFICADAS',
				},
				'stock_market': {
					'initial_slide': 0,
					'slider_items': [
						{
							'name': 'PAGAMENTO RESERVAS',
							'year': '2023',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/PagamentoReservas_Sonagi_2023.pdf',
						},
						{
							'name': 'PAGAMENTO DIVIDENDOS',
							'year': '2021',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2021.pdf',
						},
						{
							'name': 'PAGAMENTO DIVIDENDOS',
							'year': '2020',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2020.pdf',
						},
						{
							'name': 'PAGAMENTO DIVIDENDOS',
							'year': '2019',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2019.pdf',
						},
						{
							'name': 'PAGAMENTO DIVIDENDOS',
							'year': '2018',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2018.pdf',
						},
						{
							'name': 'PAGAMENTO DIVIDENDOS',
							'year': '2017',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2017.pdf',
						},
						{
							'name': 'PAGAMENTO DIVIDENDOS',
							'year': '2007',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2007.pdf',
						},
						{
							'name': 'PAGAMENTO DIVIDENDOS',
							'year': '2006',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2006.pdf',
						},
						{
							'name': 'PAGAMENTO DIVIDENDOS',
							'year': '2005',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2005.pdf',
						},
					],
				},
			},
		},
		{
			'title': 'ASSEMBLEIAS GERAIS',
			'height': 400,
			'component': 'GeneralMeeting',
			'opened': false,
			'params': {
				'initial_slide': 0,
				'slider_items': [
					{
						'name': 'PROPOSTAS ASSEMBLEIA GERAL',
						'year': '2026',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Propostas_AG_Sonagi_2026_VF.pdf',
					},
					{
						'name': 'CONVOCATÓRIA ANUAL',
						'year': '2026',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2026.pdf',
					},
					{
						'name': 'PROPOSTAS ASSEMBLEIA GERAL',
						'year': '2025',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/AG_SONAGI_2025_Propostas.pdf',
					},
					/*
					{
						'name': 'CONVOCATÓRIA ANUAL',
						'year': '2025',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2025.pdf',
					},
					{
						'name': 'PROPOSTAS ASSEMBLEIA GERAL',
						'year': '2024',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/AG_SONAGI_2024_Propostas.pdf',
					},
										{
						'name': 'PROPOSTAS ASSEMBLEIA GERAL',
						'year': '2023',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/AG_SONAGI_2023_Propostas.pdf',
					},
					{
						'name': 'CONVOCATÓRIA ANUAL',
						'year': '2024',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2024.pdf',
					},
					{
						'name': 'CONVOCATÓRIA ANUAL',
						'year': '2023',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2023.pdf',
					},
					{
						'name': 'CONVOCATÓRIA EXTRAORDINÁRIA E PROPOSTAS',
						'year': '12 DEZ 2022',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_Extraodinaria_AG_2022.pdf',
					},
					{
						'name': 'CONVOCATÓRIA ANUAL',
						'year': '2022',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2022.pdf',
					},
					*/
				],
			},
		},
		{
			'title': 'ESTATUTOS',
			'height': 400,
			'component': 'Statues',
			'opened': false,
			'params': {
				'initial_slide': 0,
				'slider_items': [
					{
						'name': 'ESTATUTOS',
						'year': '2019',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Estatutos_Sonagi_2019.pdf',
					},
				],
			},
		},
		{
			'title': 'GOVERNO SOCIETÁRIO',
			'height': 2500,
			'component': 'CorpGovernance',
			'opened': false,
			'params': {
				'trans': {
					
				},
				'team': {
					'SONAGI SGPS SA': {
						'Assembleia Geral': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/005IconWoman_AboutUs.png',
								'position': 'Presidente',
								'name': 'Joana Esperança Fernandes Lopes Luís'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/005IconWoman_AboutUs.png',
								'position': 'Secretário',
								'name': 'Daniela Filipa Dias Romeiro'
							}
						],
						'Auditor': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Efectivo',
								'name': 'KPMG & Associados – Sociedade de Revisores Oficiais de Contas, S.A., representada por Paulo Alexandre Martins Quintas Paixão'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Suplente',
								'name': 'Rui Filipe Dias Lopes'
							}
						],
						'Conselho de Administração': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Presidente',
								'name': 'Hugo Alexandre Lopes Pinto'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/005IconWoman_AboutUs.png',
								'position': 'Vogal',
								'name': 'Mafalda Mendes de Almeida de Queiroz Pereira'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Vogal',
								'name': 'Rui Tiago Trindade Ramos Gouveia'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Vogal',
								'name': 'Daniel Filipe dos Santos e Tareco'
							}
						]
					},
					'SONAGI IMOBILIÁRIA SA': {
						'Assembleia Geral': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/005IconWoman_AboutUs.png',
								'position': 'Presidente',
								'name': 'Daniela Filipa Dias Romeiro'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/005IconWoman_AboutUs.png',
								'position': 'Secretário',
								'name': 'Joana Esperança Fernandes Lopes Luís'
							}
						],
						'Auditor': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Efectivo',
								'name': 'KPMG & Associados – Sociedade de Revisores Oficiais de Contas, S.A., representada por Paulo Alexandre Martins Quintas Paixão'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Suplente',
								'name': 'Rui Filipe Dias Lopes'
							}
						],
						'Conselho de Administração': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Presidente',
								'name': 'Hugo Alexandre Lopes Pinto'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Vogal',
								'name': 'Rui Tiago Trindade Ramos Gouveia'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Vogal',
								'name': 'Daniel Filipe dos Santos e Tareco'
							}
						],
					},
				}
			},
		},
		{
			'title': 'HISTÓRIA SOCIETÁRIA',
			'height': 1800,
			'component': 'History',
			'opened': false,
			'params': {
				'trans': {
					'history': 'History'
				},
				'history': {
					'1850 - 1900': {
						'opened': false,
						'height': 300,
						'content': `<p>1868 - Constituição da Sociedade Companhia das Águas de Lisboa através do Decreto 21.879 (legislação prévia e complementar).</p>
						`
					},
					'1900 - 1950': {
						'opened': false,
						'height': 300,
						'content':	`<p>1935 - Estatutos reformulados.</p>`
					},
					'1950 - 2000': {
						'opened': false,
						'height': 1400,
						'content': `<p>1959 - Alteração de estatutos publicada no Diário do Governo nº 102. - III Série de 30/04/59.</p>
							<p>1964 - Alteração de estatutos publicada no Diário do Governo nº 92. - III Série de 17/04/64.</p>
							<p>1974 - Alteração de estatutos publicada no Diário do Governo nº 271. - III Série de 21/04/74.</p>
							<p>1977 - Alteração de estatutos publicada no Diário do Governo nº 102. - III Série de 30/05/77.</p>
							<p>1979 - Alteração da denominação social de Companhia das Águas de Lisboa para <b>SONAGI - Sociedade Nacional de Gestão e Investimentos, S.A.</b> publicada no Diário do Governo nº 286. - III Série de 13/12/79.</p>
							<p>1980 - Rectificação dos estatutos publicada no Diário da República nº 10, III série de 12/01/80.</p>
							<p>1981 - Aumento de Capital de Esc.:50 000 000$00 para Esc.:100 000 000$00 publicado no Diário da República, nº 179, III Série de 06/08/81 - Pag. 9.712.</p>
							<p>1991 - Alteração dos estatutos publicada no Diário da República, nº 137, III Série de 18/06/91 - 3º Suplemento, pág. 10.112.</p>
							<p>1992 - Aumento de Capital de Esc.:100 000 000$00 para Esc.:200 000 000$00 publicado no Diário da República, nº 138, III Série de 17/06/92 - Suplemento, pág. 10 748.</p>
							<p>1997 - Alteração dos estatutos publicada no Diário da República, nº 168, III Série de 23/07/97 (artigos 19º e 20º suprimidos e alterada a redacção do artigo 18º);</p>
							<p>2000 - Alteração dos estatutos. Redenominação das acções através de arredondamento do valor unitário para cinco Euros e consequentemente aumento do capital social em 2.404,21 Euros por incorporação de reservas livres (alteração do nº 1 do artigo 4º e o nº 4 do artigo 12º).Dispensa de publicação no Diário da República –D/L nº 343/98.</p>
							`
					},
					'2000 - Presente': {
						'opened': false,
						'height': 900,
						'content':	`<p>2002 - Alteração dos estatutos publicada no Diário da República, nº 210, III Série de 11/09/02 (alteração do artigo segundo).</p>
							<p>2003 - Alteração dos estatutos publicada no Diário da República, nº 233, III Série de 08/10/03 (alteração do artigo terceiro).</p>
							<p>2003 - Alteração da denominação social de <b>SONAGI - Sociedade Nacional de Gestão e Investimento, S.A. para SONAGI, SGPS, S.A.</b>, publicada no Diário da República, nº 292, III Série de 15/12/2004.</p>
							<p>2006 - Alteração dos estatutos publicada no Portal do Ministério da Justiça em 06/07/06. Alteração do nº1 do artigo 4º; al. a) do nº2 e nº3 do artigo 7º e nº1 do artigo 11º (alteração do valor nominal das acções de Euros 5,00 para Euros 1,00; aumento de capital social de Euros 1.000.000,00 para Euros 10.000.000,00).</p>
							<p>2019 - Fusão das empresas Longavia - Imobiliária e Sonagi - Imobiliária com a Cimilonga - Imobiliária e alteração da designação social para Sonagi - Imobiliária, S.A.</p>
						`
					},
				},
			},
		}
	],
	
	
	


	/*ABOUT US*/

	'about_title': 'QUEM SOMOS',
	'about_welcome_txt': 'Conheça a Sonagi e saiba mais sobre os seus valores, estratégia e equipa.',
	'about_intro_title': 'SOBRE NÓS',
	'about_intro_text': 'A Sonagi é uma holding imobiliária com actividade nas áreas de investimento, gestão de activos e promoção imobiliária, que tem como accionista de referência a Sodim, holding da família Queiroz Pereira.',
	'about_values': 'VALORES',
	'about_values_vision_title': 'VISÃO',
	'about_values_mission_title': 'MISSÃO',
	'about_values_vision_text': 'A Sonagi tem como objectivo vir a assumir uma posição de destaque no sector imobiliário em Portugal sendo reconhecida quer pelos seus princípios éticos quer pelos seus padrões de excelência e inovação.',
	'about_values_mission_text': 'Promover produtos e serviços imobiliários compatibilizando a criação de valor para os acionistas com uma perspetiva de desenvolvimento sustentável e com elevada consciência social e ambiental.',
	'about_themes': [
		/*{
			'title': 'PRINCÍPIOS ESTRATÉGICOS',
			'height': 600,
			'component': 'StrategicPrinciples',
			'opened': false,
			'params': {
				'trans': {
					
				},
				'content': `<p>A estratégia da Sonagi é actuar em todos os setores de atividade imobiliária:</p>

					<div>
						<p>1. Criando produtos em cada um dos seus subsetores que correspondam aos mais elevados padrões de qualidade e inovação;</p>

						<p>2. Facultando os melhores recursos e orientação num ambiente de compreensão e apoio para maximizar o sucesso e atingir os objectivos dos clientes;</p>

						<p>3. Criando relações duradouras através de padrões éticos de integridade, profissionalismo, serviço e inovação;</p>

						<p>4. Crescendo ao criar valor para o accionista mantendo sempre os seus princípios de consciência social e ambiental;</p>

						<p>5. Procurando oportunidades de negócio que permitam fazer aquisições geradoras de valor.</p>
					</div>`
			},
		},
		/*{
			'title': 'ESTATUTOS',
			'height': 50,
			'component': 'Statutes',
			'opened': false,
			'params': {
				'trans': {
					'file_name': 'Estatutos Sonagi SGPS',
				},
				'file': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Estatutos_Sonagi_2019.pdf',
			}
		},*/
		{
			'title': 'EQUIPA',
			'height': 2500,
			'component': 'Team',
			'opened': false,
			'params': {
				'trans': {
					'secretary': 'Secretariado'
				},
				'team': {
					'SONAGI IMOBILIÁRIA SA': {
						'Conselho de Administração': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'CEO',
								'name': 'Daniel Tareco'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Director Financeiro',
								'name': 'Carlos Ferreira'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+ 'img/004IconMan_AboutUs.png',
								'position': 'Director Gestão de Activos',
								'name': 'João Lúcio'
							}
						],
						/** 
						'Quadros Superiores': [
							
						]
						*/

					},
				}
			}
		},
		/*{
			'title': 'FACTOS HISTÓRICOS DA EMPRESA',
			'height': 1800,
			'component': 'History',
			'opened': false,
			'params': {
				'trans': {
					'history': 'History'
				},
				'history': {
					'1850 - 1900': {
						'opened': false,
						'height': 300,
						'content': `<p>1868 - Constituição da Sociedade Companhia das Águas de Lisboa através do Decreto 21.879 (legislação prévia e complementar).</p>
						`
					},
					'1900 - 1950': {
						'opened': false,
						'height': 300,
						'content':	`<p>1935 - Estatutos reformulados.</p>`
					},
					'1950 - 2000': {
						'opened': false,
						'height': 1400,
						'content': `<p>1959 - Alteração de estatutos publicada no Diário do Governo nº 102. - III Série de 30/04/59.</p>
							<p>1964 - Alteração de estatutos publicada no Diário do Governo nº 92. - III Série de 17/04/64.</p>
							<p>1974 - Alteração de estatutos publicada no Diário do Governo nº 271. - III Série de 21/04/74.</p>
							<p>1977 - Alteração de estatutos publicada no Diário do Governo nº 102. - III Série de 30/05/77.</p>
							<p>1979 - Alteração da denominação social de Companhia das Águas de Lisboa para <b>SONAGI - Sociedade Nacional de Gestão e Investimentos, S.A.</b> publicada no Diário do Governo nº 286. - III Série de 13/12/79.</p>
							<p>1980 - Rectificação dos estatutos publicada no Diário da República nº 10, III série de 12/01/80.</p>
							<p>1981 - Aumento de Capital de Esc.:50 000 000$00 para Esc.:100 000 000$00 publicado no Diário da República, nº 179, III Série de 06/08/81 - Pag. 9.712.</p>
							<p>1991 - Alteração dos estatutos publicada no Diário da República, nº 137, III Série de 18/06/91 - 3º Suplemento, pág. 10.112.</p>
							<p>1992 - Aumento de Capital de Esc.:100 000 000$00 para Esc.:200 000 000$00 publicado no Diário da República, nº 138, III Série de 17/06/92 - Suplemento, pág. 10 748.</p>
							<p>1997 - Alteração dos estatutos publicada no Diário da República, nº 168, III Série de 23/07/97 (artigos 19º e 20º suprimidos e alterada a redacção do artigo 18º);</p>
							<p>2000 - Alteração dos estatutos. Redenominação das acções através de arredondamento do valor unitário para cinco Euros e consequentemente aumento do capital social em 2.404,21 Euros por incorporação de reservas livres (alteração do nº 1 do artigo 4º e o nº 4 do artigo 12º).Dispensa de publicação no Diário da República –D/L nº 343/98.</p>
							`
					},
					'2000 - Presente': {
						'opened': false,
						'height': 900,
						'content':	`<p>2002 - Alteração dos estatutos publicada no Diário da República, nº 210, III Série de 11/09/02 (alteração do artigo segundo).</p>
							<p>2003 - Alteração dos estatutos publicada no Diário da República, nº 233, III Série de 08/10/03 (alteração do artigo terceiro).</p>
							<p>2003 - Alteração da denominação social de <b>SONAGI - Sociedade Nacional de Gestão e Investimento, S.A. para SONAGI, SGPS, S.A.</b>, publicada no Diário da República, nº 292, III Série de 15/12/2004.</p>
							<p>2006 - Alteração dos estatutos publicada no Portal do Ministério da Justiça em 06/07/06. Alteração do nº1 do artigo 4º; al. a) do nº2 e nº3 do artigo 7º e nº1 do artigo 11º (alteração do valor nominal das acções de Euros 5,00 para Euros 1,00; aumento de capital social de Euros 1.000.000,00 para Euros 10.000.000,00).</p>
						`
					},
				},
			},
		}*/
	],

	/*PORTFOLIO*/

	'portfolio_title': 'PORTFÓLIO',
	'description': 'DESTAQUES',
	'availability': 'DISPONIBILIDADE',
	'related_projects_txt': 'PROJETOS RELACIONADOS',
	'availability_href_txt': 'Clique aqui para saber mais',
	'portfolio_welcome_txt':  'Saiba mais sobre os nossos investimentos imobiliários.',
	'projects_categories': [
		{
			'name': 'INVESTIMENTO<br>IMOBILIÁRIO',
			'name_portfolio': 'PROPRIEDADES DE INVESTIMENTO',
			'slug': 'real-estate-investement',
			'thumb': process.env.VUE_APP_ASSETS_ROOT+ 'img/RealEstateInvestment_FeaturedPortfolio.jpg',
			'show_on_home': true,
		},
		{
			'name': 'PROMOÇÃO<br>IMOBILIÁRIA',
			'name_portfolio': 'PROMOÇÃO IMOBILIÁRIA',
			'slug': 'real-estate-promotion',
			'thumb': process.env.VUE_APP_ASSETS_ROOT+ 'img/RealEstatePromotion_FeaturedPortfolio.jpg',
			'show_on_home': true,
		},
		{
			'name': 'TODOS',
			'name_portfolio': 'TODOS',
			'slug': 'all',
			'thumb': process.env.VUE_APP_ASSETS_ROOT+ 'img/DevelopedProjects_FeaturedPortfolio.jpg',
			'show_on_home': false,
		}
	],
	'projects': [
		{
			'id': 1,
			'name': 'FONTES PEREIRA DE MELO 14',
			'slug': 'fpm14',
			'tab_title': 'Fontes Pereira de Melo 14',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Escritórios prime business district',
			'abreviature': 'FPM14',
			'related_projects': [2, 12, 13],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '8.300 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floor_PaginaProjeto.svg',
					'description': '600 m<sup>2</sup>/piso'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': '15 pisos'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/Y5wpj5qfvBLkde649'
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_FPM14.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_FPM14.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_FPM14.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Este edifício corporativo situa-se em pleno centro da cidade, numa das localizações de negócios mais conceituadas de Lisboa. Localizado a poucos metros da Praça Marquês de Pombal, foi desde a sua construção sede de diversas empresas de prestígio. Continuamente em actualização, articula as exigênciais dos escritórios actuais com a arquitectura intemporal.',
			'description': '- Prime Business District<br>- Bons acessos à rede de transportes públicos<br>- Principais inquilinos: Semapa, LinkLaters, Auto Industrial<br>- Estacionamento em cave',
			'availability': 'Sem disponibilidade',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM14_24.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM14_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM14_25.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM14_23.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM14_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM14_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM14_12.jpg',
			]
		},
		{
			'id': 2,
			'name': 'FONTES PEREIRA DE MELO 21',
			'slug': 'fpm21',
			'tab_title': 'Fontes Pereira de Melo 21',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Escritórios prime business district',
			'abreviature': 'FPM21',
			'related_projects': [2, 3, 5],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '1.980 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floor_PaginaProjeto.svg',
					'description': '204 m<sup>2</sup>/piso'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': '10 pisos'
				},
			/*	/{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/NuaE3jvpscbEzuZc8'
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_FPM21.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_FPM21.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_FPM21.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Este edifício situa-se no coração da cidade, numa localização prime associada ao prestígio empresarial. Trata-se de um edifício de qualidade, com escritórios de média dimensão, servido por uma excelente rede de transportes. Dispondo de todas as comodidades necessárias, é a solução ideal para o funcionamento de empresas que privilegiam um ambiente corporativo.',
			'description': '- Prime Business District<br>- Bons acessos à rede de transportes públicos<br>- Principais inquilinos: Olhar de Prata, Optimize, Notário Frederico Soares Franco, Integrative Medicine<br>- Estacionamento em cave',
			'availability': 'Sem disponibilidade',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_37.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_3.jpg',
			/*	process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFPM21_8.jpg', */
			]
		},
		{
			'id': 3,
			'name': 'ANTÓNIO AUGUSTO DE AGUIAR 122',
			'slug': 'aaa122',
			'tab_title': 'António Augusto de Aguiar 122',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Escritórios prime business district',
			'abreviature': 'AAA122',
			'related_projects': [2, 3, 5],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '5.800 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floor_PaginaProjeto.svg',
					'description': '480 m<sup>2</sup>/piso'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': '16 pisos'
				},
			/*	/{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/NuaE3jvpscbEzuZc8'
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_AAA112_2.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_AAA112_2.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_AAA112_2.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Este edifício situa-se junto ao Corte Inglês e à estação de metro de São Sebastião. Em 2022 foi objecto de uma renovação integral, passando a cumprir todos os standards dos escritórios actuais.',
			'description': '- Prime Business District<br>- Proximidade do Corte Inglês<br>- Bons acessos à rede de transportes públicos<br>- Estacionamento em cave<br>- Inquilino: IdeaSpaces',
			'availability': 'Sem disponibilidade',
			'initial_slide': 0,
			'slider_images': [
				/* process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_1.jpg', 
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_2.jpg',
				/*process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_4.jpg',
				/*process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_7.jpg' */
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_8.jpg', 
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_12.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_13.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_14.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_15.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_16.jpg'
			]
		},
		{
			'id': 15,
			'name': 'JEAN MONNET 1',
			'slug': 'jm1',
			'tab_title': 'Jean Monnet 1',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Escritórios prime business district',
			'abreviature': 'JM1',
			'related_projects': [1, 2, 3],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '6.500 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floor_PaginaProjeto.svg',
					'description': '805 m<sup>2</sup>/piso'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': '8 pisos'
				}
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_JM1.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_JM1.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_JM1.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Edifício emblemático, localizado no Prime CBD, junto ao eixo da Avenida da Liberdade, na área de negócios mais privilegiada da cidade. Conta na sua envolvente com diversas áreas de comércio e unidades hoteleiras de prestígio, sendo servido de excelente rede de transportes. Após uma profunda renovação durante o ano de 2024 , o edifício está totalmente adaptado às actuais necessidades do mercado de escritórios.',
			'description': '- Prime Business District<br>- Bons acessos à rede de transportes públicos<br>- Principais inquilinos: Explorer, Insula, InformaDB, MFA Legal<br>- Estacionamento em cave',
			'availability': 'Sem disponibilidade',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_6.jpg'
			]
		},
		{
			'id': 4,
			'name': 'JOAQUIM ANTÓNIO DE AGUIAR 66',
			'slug': 'jaa66',
			'tab_title': 'Joaquim António de Aguiar 66',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Escritórios',
			'abreviature': 'JAA66',
			'related_projects': [2, 13, 12],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '3.800 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floor_PaginaProjeto.svg',
					'description': '554 m<sup>2</sup>/piso'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': '8 pisos'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/FU72dbU3Yiv8NsAv9'				
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_JAA66.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_JAA66.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_JAA66.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Este edifício, situado no cruzamento da Rua Artilharia I com a Rua Joaquim António de Aguiar, foi sede de diversas sociedades de advogados. Situado no eixo Marquês de Pombal - Amoreiras, disponibiliza escritórios de qualidade, com todas as condições técnicas necessárias ao funcionamento de empresas.',
			'description': '- Eixo Marquês de Pombal/Amoreiras<br>- Bons acessos à rede de transportes públicos<br>- Principais inquilinos: Summer C Colors, ArgoTalents, ATPR Advogados<br>- Estacionamento térreo',
			'availability': '',
			'availability_hrefs': [
				{
					'href': 'https://www.worx.pt/pt/imoveis/edificio-joaquim-antonio-aguiar-66',
					'text': 'Worx'
				},
				{
					'href': 'https://jllproperty.pt/arrendar-escritorio/escritorio-para-arrendar-lisboa-931',
					'text': 'JLL'
				}
			],
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJAA66_6.jpg',
			]
		},
		/*{
			'id': 5,
			'name': 'CICAS',
			'slug': 'cicas',
			'tab_title': 'Cicas',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Comércio e indústria',
			'abreviature': 'CICAS',
			'related_projects': [4, 6, 9],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '3.020 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Buildings_PaginaProjeto.svg',
					'description': '4 edifícios'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Carnaxide',
					'href': 'https://goo.gl/maps/3CzeHYMPz13f9ZfL9'	
				}, 
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_Cicas.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_Cicas.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_CICAS.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'A antiga fábrica de cabos da Delphy fica situada na rotunda das Cicas, a Sul do Hospital de Santa Cruz. Com uma arquitectura moderna e actual, tem sido sucessivamente ocupada por empresas do ramo automóvel.',
			'description': '- Estacionamento privativo<br>- Bons acessos rodoviários<br>- Proximidade de Lisboa<br>- Inquilino: Leaseplan',
			'availability': 'Sem disponibilidade',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCicas6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCicas7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCicas5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCicas2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCicas9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCicas3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCicas8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCicas1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCicas4.jpg',
			]
		}, */
		{
			'id': 7,
			'name': 'FRANCISCO MANUEL DE MELO 12',
			'slug': 'fmm12',
			'tab_title': 'Francisco Manuel de Melo 12',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Habitação e comércio',
			'abreviature': 'FMM12',
			'related_projects': [14, 3, 11],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '1.623 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floor_PaginaProjeto.svg',
					'description': '182 m<sup>2</sup>/piso'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Buildings_PaginaProjeto.svg',
					'description': '5 apartamentos'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/PkcLwesstrXd6WJt7'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_FMM12.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_FMM12.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_FMM12.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Este edifício, situado no centro de Lisboa, está integrado numa zona de prestígio da cidade. Localizado junto ao Hotel Ritz, Parque Eduardo VII, Praça Marquês de Pombal e Centro Comercial das Amoreiras, conta com acessos facilitados aos transportes da área metropolitana de Lisboa, assim como, excelentes acessos rodoviários (Eixo Norte/Sul, A2 e A5).',
			'description': '- Localização central<br>- Bons acessos à rede de transportes públicos',
			'availability': 'Sem disponibilidade',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_7.jpg',
			/*	process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiFMM12_1.jpg', */
			]
		},
		{
			'id': 8,
			'name': 'AZINHAGA DAS GALHARDAS',
			'slug': 'galhardas',
			'tab_title': 'Azinhaga das Galhardas',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Comércio',
			'abreviature': 'GALHARDAS',
			'related_projects': [2, 3, 5],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '4.030 m<sup>2</sup>'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/rHBPiuTsSKVyGSCBA'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_Galhardas.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_Galhardas.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_GALHARDAS.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Inserido num empreendimento residencial de grande qualidade, situado em Telheiras, nas imediações do Estádio Universitário e da Universidade Católica. Trata-se de um embasamento, ocupado por uma superfície comercial . Dispõe de acessos aos transportes da área metropolitana de Lisboa e de excelentes acessos rodoviários (Eixo Norte/Sul e 2ª Circular).',
			'description': '- Eixo Praça de Espanha/2.º Circular<br>- Bons acessos rodoviários<br>- Estacionamento público<br>- Inquilino: Pingo Doce',
			'availability': 'Sem disponibilidade',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiGalhardas_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiGalhardas_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiGalhardas_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiGalhardas_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiGalhardas_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiGalhardas_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiGalhardas_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiGalhardas_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiGalhardas_8.jpg',
			]
		},
		{
			'id': 9,
			'name': 'PARQUE DAS CICAS',
			'slug': 'parque-cicas',
			'tab_title': 'Parque das Cicas',
			'dinamic_title': 'PROJECTISTAS',
			'teaser': 'Habitação e escritórios',
			'abreviature': 'PARQUE DAS CICAS',
			'related_projects': [5, 11, 8],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '37.870 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '4 lotes'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/CygxZP3qJ6fdurB59'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_PCicas.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_PCicas.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_PCicas.jpg',
			'categories': ['real-estate-promotion', 'all'],
			'text': 'Os pavilhões industriais da antiga fábrica de cabos, adquirida em 2003, foram inicialmente adaptados para logística, uso que mantêm. Situado no prolongamento natural da área residencial de Carnaxide, contíguo ao Hospital de Santa Cruz e ao Parque Holanda (complexo de escritórios e logística), esta "ilha" industrial irá brevemente sofrer uma reconversão urbanística, ajustando-se à realidade envolvente.',
			'description': '<a href="https://www.cunhaferreira-arquitectos.pt/" target="_blank">Cunha Ferreira Arquitectos</a>',
			'availability': 'Licenciamento em curso',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiPCicas_1.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiPCicas_2.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiPCicas_3.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiPCicas_4.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiPCicas_5.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiPCicas_6.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiPCicas_7.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiPCicas_8.jpeg',
			]
		},
		{
			'id': 6,
			'name': 'MEM MARTINS BUSINESS PARK',
			'slug': 'mmbp',
			'tab_title': 'Mem Martins Business Park',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Escritórios e logística',
			'abreviature': 'MMBP',
			'related_projects': [4, 5, 9],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '13.205 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Buildings_PaginaProjeto.svg',
					'description': '8 edifícios'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Sintra',
					'href': 'https://goo.gl/maps/KV8ahYtRuxhP4gTbA'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_MBP.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_MBP.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_MBP_pb.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Situado em Mem Martins junto ao Sintra Retail Park, a escassos 15km de Lisboa, este parque empresarial conta com 6 pavilhões de logística e 2 edifícios de escritórios. Prevê-se para breve a ampliação da área de logística, com a construção de 8 novos armazéns, dotados de cais de carga e descarga. Propriedade da Sonagi entre 2005 e 2026.',
			'description': '- Parque empresarial fechado com segurança<br>- Próximidade do IC19 e A16',
			'availability': 'Armazéns com 1.230 m<sup>2</sup> e 240 m<sup>2</sup>',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMBP_2.jpg',
			]
		},
		{
			'id': 5,
			'name': 'ALFA',
			'slug': 'alfa',
			'tab_title': 'Alfa',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Escritórios e logística',
			'abreviature': 'ALFA',
			'related_projects': [5, 6, 9],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '4.650 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Warehouse_PaginaProjeto.svg',
					'description': '3 armazéns'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': '3 pisos de escritórios'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Carnaxide',
					'href': 'https://goo.gl/maps/ACdqTBvyF72Jk3nw8'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_ALFA.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_ALFA.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_ALFA2.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Situado em Carnaxide, junto à entrada da A5, este edifício dispõe de grandes áreas de escritórios e de logística, ideal para sedes de empresas com estas necessidades. Propriedade da Sonagi entre 2006 e 2026.',
			'description': '- Armazéns com pé-direito elevado<br>- Parque privativo coberto<br>- Estacionamento adicional no logradouro',
			'availability': 'Sem disponibilidade',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa12.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa2.jpg',
			/*	process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiAlfa3.jpg', */
			]
		},
		{
			'id': 10,
			'name': 'ALDEIA DA ROCA',
			'slug': 'Roca',
			'tab_title': 'Aldeia da Roca',
			'dinamic_title': 'PROJECTISTAS',
			'teaser': 'Habitação',
			'abreviature': 'ALDEIA DA ROCA',
			// 'related_projects': [11, 7, 14],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '2.850 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Buildings_PaginaProjeto.svg',
					'description': '16 apartamentos'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Sintra',
					'href': 'https://goo.gl/maps/g7xuGM7Npe8bRRcw5'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_ROCA.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_ROCA.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_ROCA.jpg',
			'categories': ['real-estate-promotion', 'all'],
			'text': 'Situado na Azóia, junto ao Cabo da Roca, em pleno Parque Natural Sintra Cascais, este empreendimento residêncial disponibilizará apartamentos com vista panorâmica sobre a serra e sobre o mar. A 35 minutos de Lisboa e a 10 minutos da Praia do Guincho ou da Praia Grande, apresenta-se como um aprazível reduto de natureza e tranquilidade.',
			'description': '<a href="https://www.antoniocostalima.com/" class="icon-link" target="_blank">António Costa Lima Arquitectos</a>',
			'availability': 'Licenciamento em curso',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRoca_12.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRoca_13.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRoca_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRoca_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRoca_14.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRoca_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRoca_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRoca_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRoca_10.jpg',
			]
		},
		{
			'id': 11,
			'name': 'MIGUEL BOMBARDA 95',
			'slug': 'mb95',
			'tab_title': 'Miguel Bombarda 95',
			'dinamic_title': 'PROJECTISTAS',
			'teaser': 'Habitação e comércio',
			'abreviature': 'MB95',
			'related_projects': [1, 14, 8],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '3.935 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Stores_PaginaProjeto.svg',
					'description': '3 lojas'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Buildings_PaginaProjeto.svg',
					'description': '17 apartamentos'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/CygxZP3qJ6fdurB59'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_MB95.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_MB95.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_MB95.jpg',
			'categories': ['real-estate-promotion', 'all'],
			'text': 'Situado nas Avenidas Novas, no gaveto de duas amplas avenidas ladeadas por jacarandás, este edifício concluído em 2014 tem um enquadramento singular. Implantado diante de um jardim, a escassas dezenas de metros dos dinâmicos eixos do mundo dos negócios, permite simultaneamente disfrutar a tranquilidade e a vivacidade citadina: vaguear pelas ciclovias, usufruir dos jardins da Gulbenkian, do El Corte Inglés, das mercearias de bairro e dos sabores da Versailles.',
			'description': '<a href="https://www.arch-rms.com/" target="_blank">Rodrigo Machado Soares</a>',
			'availability': 'Vendido',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_12.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_14.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_8.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_2.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_4.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_10.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiMB95_13.jpg',
			]
		},
		{
			'id': 12,
			'name': 'EDIFÍCIO OPEN',
			'slug': 'open-building',
			'tab_title': 'Edifício Open',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Escritórios',
			'abreviature': 'EDIFÍCIO OPEN',
			'related_projects': [1, 2, 3],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '7.430 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': '13 pisos'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/rw8wisiZgqwGKbLPA'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_OPEN.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_OPEN.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_OPEN.jpg',
			'categories': ['real-estate-promotion', 'real-estate-investement', 'all'],
			'text': 'Situado na Avenida das Forças Armadas em Lisboa junto ao Hospital de Santa Maria e à cidade Universitária, caracteriza-se como um edifício de escritórios de boa qualidade com lojas, cafetaria e segurança 24h. De arquitectura moderna, é composto por várias janelas em toda a sua fachada, oferecendo assim muita luz natural. Dispõe ainda de estacionamento público e privado.',
			'description': '- Escritórios de elevada qualidade<br>- Arquitectura moderna<br>- Áreas em open space',
			'availability': 'n/a',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiOpen_3.jpg',
			]
		},
		{
			'id': 13,
			'name': 'CENTRAL PARK',
			'slug': 'centralpark',
			'tab_title': 'Central Park',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Escritórios e comércio',
			'abreviature': 'CENTRAL PARK',
			'related_projects': [12, 1, 3],
			'icons': [
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': 'X m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': 'X pisos'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/ULxB3ksC1rKb7ZXf9'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_CentralPark.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_CentralPark.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_CENTRALPARK.jpg',
			'categories': ['real-estate-promotion', 'real-estate-investement', 'all'],
			'text': 'Este edifício está localizado na principal avenida de Linda-a-velha junto ao acesso da A5. Caracteriza-se como um edifício misto que beneficia de uma grande variedade de serviços (C.C Dolce Vita), assim como, de uma ampla zona de escritórios de boa qualidade. Todos os escritórios dispõe de modernas comodidades essenciais para as empresas.',
			'description': '- Edifício de escritórios e comércio<br>- Construção de elevada qualidade<br>- Áreas em open space',
			'availability': 'n/a',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCentralPark1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCentralPark2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCentralPark9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCentralPark7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCentralPark8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCentralPark3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCentralPark4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCentralPark5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiCentralPark6.jpg',
			]
		},
		{
			'id': 14,
			'name': 'RODRIGUES SAMPAIO 52',
			'slug': 'rs52',
			'tab_title': 'Rodrigues Sampaio 52',
			'dinamic_title': 'DESTAQUES',
			'teaser': 'Habitação e comércio',
			'abreviature': 'RS52',
			'related_projects': [7, 11, 8],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floor_PaginaProjeto.svg',
					'description': '240 m<sup>2</sup>/piso'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': '6 pisos'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/5KwMfY4WjMFFDPQw7'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_RS52.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_RS52.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_RS52.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Este edifício de habitação e comércio situa-se em pleno coração de Lisboa, na esquina de acesso à rua de maior notoriedade da cidade. a Avenida da Liberdade. Conhecida como os Champs Elysées portugueses, aqui é possível encontrar lojas e empresas de prestígio mundial. Em contraste aberto com esta modernidade, o edifício sobressai como ícone da arquitectura tradicional, espelhando na sua fachada a estética eclética dos anos 50.',
			'description': '- Propriedade da SONAGI entre 1954 e 2006<br>- Localização central<br>- Arquitectura tradicional portuguesa',
			'availability': 'n/a',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiRS52_10.jpg',				
			]
		}
	],

	
	/*CONTACTS*/
	
	'contacts_title': 'CONTACTOS',
	'contacts_txt': 'Se precisar de alguma informação adicional, não hesite em entrar em contacto.',
	'address': 'MORADA',
	'phone': 'TELEFONE',



	/*404 PAGE*/


	'404_error_title': 'A PÁGINA QUE PROCURA NÃO EXISTE.',
	'404_error_text': 'Erro 404'
}